import axios from "axios";

const bagnoArrivalModule = {
  namespaced: true,
  state: {
    items: [],
    selected: [],
    containers: [{ text: "Cargando...", value: null }],
    total_kg: 0
  },
  getters: {
    totalNet: (state) => {
      if (state.items.length > 0) {
        return state.items.reduce((acc, item) => acc + item.net_weight, 0);
      } else {
        return 0;
      }
    },
    totalQuantity: (state) => {
      return state.items.reduce((acc, item) => acc + item.quantity, 0);
    },
    checkCompletedPallet(state, getters) {
      return getters.completedPallet / state.items.length === 1;
    },
    completedPallet: (state) => {
      return state.items.reduce((r, o) => r + +!Object.values(o).includes(null), 0);
    },
    itemsSelectedCount: (state) => {
      return state.selected.length;
    },
    netExceeded(state, getters) {
      return parseFloat(getters.totalNet) - parseFloat(state.total_Kg);
    }
  },
  mutations: {
    addRows(state, payload) {
      let current_index = state.items.length;
      if (current_index > 0) {
        current_index = Math.max.apply(
          Math,
          state.items.map((o) => o.idx)
        );
      }

      for (let i = 0; i < payload.pallet_quantity; i++) {
        let d = new Date().getTime();
        let n = current_index + i + 1;
        state.items.push({
          idx: current_index + i + 1,
          number: d + "R" + n,
          lot: payload.lot,
          code: payload.code,
          description: payload.description,
          product_id: payload.product_id,
          quantity: payload.quantity,
          gross_weight: 0,
          net_weight: 0,
          container: payload.container,
          material_weight: payload.material_weight,
          selected: false,
          pallet_type: payload.pallet_type,
          is_mix: payload.is_mix,
          sub_items: []
        });
      }
    },

    updateRow(state, payload) {
      const objIndex = state.items.findIndex((obj) => obj.idx === payload.id);
      state.items[objIndex].quantity = payload.quantity;
      state.items[objIndex].container = payload.container;
      state.items[objIndex].gross_weight = payload.gross_weight;
      state.items[objIndex].net_weight = payload.netWeight;
      state.items[objIndex].product_id = payload.product.id;
      state.items[objIndex].is_mix = payload.product.is_mix;
      state.items[objIndex].description = payload.product.name;
      state.items[objIndex].code = payload.product.code;
      state.items[objIndex].container = payload.container;
    },

    updateRowToMix(state, payload) {
      const objIndex = state.items.findIndex((obj) => obj.idx === payload.id);
      state.items[objIndex].is_mix = payload.is_mix;
    },

    selectRow(state, payload) {
      state.items[payload].selected = !state.items[payload].selected;
    },

    addRowsToSelected(state, payload) {
      state.selected = payload;
    },

    removeAll(state) {
      state.items = [];
      state.selected = [];
      state.containers = [{ text: "Cargando...", value: null }];
    },

    removeRows(state, payload) {
      let deleteIndex = state.items.findIndex((obj) => obj.idx === payload.idx);
      state.items.splice(deleteIndex, 1);
    },
    getContainers(state, payload) {
      state.containers = payload;
    },
    clearSelected(state) {
      state.selected = [];
    },
    updateTotalKg(state, payload) {
      state.total_kg = payload;
    },
    addMixRow(state, payload) {
      const objIndex = state.items.findIndex((obj) => obj.idx === payload.id);
      let current_index = state.items[objIndex].sub_items.length;
      if (current_index > 0) {
        current_index = Math.max.apply(
          Math,
          state.items[objIndex].sub_items.map((o) => o.idx)
        );
      }

      let d = new Date().getTime();
      let n = current_index + 1;
      payload.item.number = d + "D" + n;
      payload.item.idx = n;

      state.items[objIndex].sub_items.push({
        idx: n,
        number: d + "R" + payload.id + "D" + n,
        lot: null,
        code: payload.item.product.code,
        description: payload.item.product.name,
        product_id: payload.item.product.id,
        quantity: payload.item.quantity,
        gross_weight: payload.item.gross_weight,
        net_weight: payload.item.net_weight,
        material_weight: 0
      });
    }
  },
  actions: {
    updateRowToMix: ({ commit }, payload) => {
      commit("updateRowToMix", payload);
    },
    updateTotalKg: ({ commit }, payload) => {
      commit("updateTotalKg", payload);
    },
    addRows: ({ commit }, payload) => {
      commit("addRows", payload);
    },
    addRowsToSelected: ({ commit }, payload) => {
      commit("addRowsToSelected", payload);
    },
    selectRow: ({ commit }, payload) => {
      commit("selectRow", payload);
    },
    updateRow: ({ commit }, payload) => {
      commit("updateRow", payload);
    },
    removeRows: ({ commit }, payload) => {
      commit("removeRows", payload);
    },
    removeAll: ({ commit }) => {
      commit("removeAll");
    },
    clearSelected: ({ commit }) => {
      commit("clearSelected");
    },
    getContainers: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        let url = "/bagno/container/select_container/?finished_product=";
        url += payload === "PALLETS";

        axios
          .get(url)
          .then((res) => {
            const data = res.data;
            let containers = [];
            for (let key in data) {
              const container = data[key];
              containers.push(container);
            }
            payload = containers;
            commit("getContainers", payload);
            resolve(res);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    addMixRow: ({ commit }, payload) => {
      commit("addMixRow", payload);
    }
  }
};

export default bagnoArrivalModule;
